@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.override.shipmentSelectMenuList {
  max-height: 198px;
}

.airlineImg {
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.placeholder {
  display: flex;
  align-items: center;
  gap: 8px;
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
}

.optionCode {
  @include t.text(12px, 16px, 600);
  color: v.$palette-gray-600;
  min-width: 28px;
}
